import { LocationPageProps } from '@scenes/LocationPage/locationPage.types';

export const makeRatingJsonLd = (rating?: LocationPageProps['ratingAttributes']) => {
  if (!rating || !rating.ratingCount) return null;

  const { rating: rv, ratingCount } = rating;
  return {
    aggregateRating: {
      ratingValue: rv,
      ratingCount,
    },
  };
};
